module.exports = __webpack_public_path__ + "media/images/check-1-f97e3bfc141df04c46592c3d5270f01e.png";